import { Box, Heading } from '@hover/blueprint';
import React from 'react';

const NotFound = () => (
  <Box
    alignItems="center"
    height="100%"
    justifyContent="center"
    testId="not-found"
    width="100%"
  >
    <Heading size={700}>404</Heading>
  </Box>
);

export { NotFound };
